// extracted by mini-css-extract-plugin
export default {"dropdown":"hover-card_dropdown__SM+HW"};